import usePermission from "src/business-types/grocery/hooks/usePermission";

// permissionKeys.ts
export const PERMISSIONS = {
  PRODUCT: {
    VIEW: "product_view",
    CREATE: "product_create",
    UPDATE: "product_update",
    DELETE: "product_delete",
  },
  CUSTOMER: {
    VIEW: "customer_view",
    CREATE: "customer_create",
    UPDATE: "customer_update",
    DELETE: "customer_delete",
  },
  CATEGORY: {
    VIEW: "category_view",
    CREATE: "category_create",
    UPDATE: "category_update",
    DELETE: "category_delete",
  },
  ORDER: {
    CANCEL: "order_cancel",
    VIEW: "order_view",
    CREATE: "order_create",
    UPDATE: "order_update",
    DELETE: "order_delete",
  },
  USER: {
    VIEW: "user_view",
    CREATE: "user_create",
    UPDATE: "user_update",
    DELETE: "user_delete",
  },
  STAFF: {
    VIEW: "staff_view",
    CREATE: "staff_create",
    UPDATE: "staff_update",
    DELETE: "staff_delete",
  },
  PROFILE: {
    UPDATE: "profile_update",
  },
};

export const useCheckPermission = () => {
  const { hasPermission } = usePermission();

  const checkPermission = (permission: string) => {
    return hasPermission(permission);
  };

  return { checkPermission };
};
